import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { getLookup } from 'app/app.module';
import { ActivatedRoute } from '@angular/router';
import { ThesaurusPath } from '@interfaces/thesaurus-path.interface';

@Injectable({
  providedIn: 'root'
})

export class UtilitiesService {

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
  ) {};
  
  getThesaurusServiceURL() {
    return this.http.get('/serviceurl', {responseType: 'text'});
  }

  getThesaurusServiceURLSynchronous() {
      return this.getThesaurusServiceURL().toPromise();
  }

  //When the value of the lookup query parameter is true, it is used to display the No Frills view of the Lexicon thesaurus
  getLookupQueryParam() {
    return getLookup(this.route.snapshot.queryParams['amp;lookup']);
  }

  getPathIdentifier(path: ThesaurusPath[]): string {
    if (!path || path.length === 0 || path[0].terms.length === 0) {
        return '';
    }
    if (path[0].tn) {
        return "-" + path[0].tn;
    }
    else {
        return "-" + path[0].terms.map(t => t.termOrdinal).join('-');
    }
  }
}
